import * as $ from 'jquery';
import * as countryStateSetup from '../modules/countryStateSetup';
import * as formValidation from '../modules/formValidation';
import TranslationsService from '../services/translationsService';
import 'url-search-params-polyfill';
declare const grecaptcha: any;

namespace PFF.controllers.freeReplacementParts {

	// Init translations service
	const translationsService = TranslationsService.getInstance();
	let translationStrings = JSON.parse($("#translations").html());
	translationsService.init(translationStrings);

	let $form = $('form');
	let $alertSuccess = $('.js-alert-success');
	let $alertDanger = $('.js-alert-danger');
	let $replacementPartsForm = $('#freereplacementparts');
	let $firstName = $('#first-name');
	let $lastName = $('#last-name');
	let $email = $('#email');
	let $emailConfirm = $('#email-confirm');
	let $address = $('#address');
	let $address2 = $('#address2');
	let $country = $('#country');
	let $city = $('#city');
	let $stateProvince = $('#state-province');
	let $postalCode = $('#postal-code');
	let $phone = $('#phone');

	let $model = $('#model');
	let $purchaseYear = $('#purchase-year');

	let $terms = $('#terms');
	let $optIn = $('#opt-in');

	let $replacementItem = $('#replacement-item');

	let $submit = $('#submit');
	let $pleaseWait = $('#please-wait');

	let constraints = {
		'first-name': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.FirstNameRequired')
			}
		},
		'last-name': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.LastNameRequired')
			}
		},
		email: {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.EmailRequired')
			},
			email: {
				message: '^' + translationsService.translate('FormValidationErrors.EmailInvalid')
			}
		},
		'email-confirm': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.ConfirmEmailRequired')
			},
			equality: {
				attribute: 'email',
				message: '^' + translationsService.translate('FormValidationErrors.ConfirmEmailInvalid')
			}
		},
		address: {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.AddressRequired')
			}
		},
		address2: {
			presence: false
		},
		country: {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.CountryRequired')
			}
		},
		city: {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.CityRequired')
			}
		},
		'state-province': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.StateRequired')
			}
		},
		'postal-code': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.PostalCodeRequired')
			}
		},
		phone: {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.PhoneRequired')
			},
			format: {
				pattern: /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
				message: '^' + translationsService.translate('FormValidationErrors.PhoneInvalid')
			}
		},

		'model': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.ModelRequired')
			}
		},
		'purchase-year': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.PurchaseYearRequired')
			}
		},
		terms: {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.Terms')
			},
		},
		'recaptcha-token': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.CaptchaRequired')
			}
		}
	};

	let validateField = function () {
		$(this).addClass('dirty');
		if (formValidation.validateWrapper({
			constraints: constraints,
			values: {
				'first-name': $firstName.val(),
				'last-name': $lastName.val(),
				email: $email.val(),
				'email-confirm': $emailConfirm.val(),
				address: $address.val(),
				address2: $address2.val(),
				country: $country.val(),
				city: $city.val(),
				'state-province': $stateProvince.val(),
				'postal-code': $postalCode.val(),
				phone: $phone.val(),

				'model': $model.val(),
				'purchase-year': $purchaseYear.val(),
				'recaptcha-token': grecaptcha.getResponse(),
				terms: $terms.prop('checked') ? 1 : undefined
			}
		})) {
			// disable submit button
			$submit.removeAttr('disabled');
		} else {
			// enable submit button
			$submit.attr('disabled', true);
		}
	};

	let inputEventListeners = function () {
		$firstName.on('blur change', validateField);
		$lastName.on('blur change', validateField);
		$email.on('blur change', validateField);
		$emailConfirm.on('blur change', validateField);
		$address.on('blur change', validateField);
		$address2.on('blur change', validateField);
		$country.on('blur change', validateField);
		$city.on('blur change', validateField);
		$stateProvince.on('blur change', validateField);
		$postalCode.on('blur change', validateField);
		$phone.on('blur change', validateField);

		$model.on('blur change', validateField);
		$purchaseYear.on('blur change', validateField);

		$terms.on('blur change', validateField);
		grecaptcha.ready(() => {
			grecaptcha.render( document.getElementById('g-recaptcha'), {
				callback: validateField
			});
		});
	};

	let submitEventListener = function () {
		$submit.on('click', function (e) {
			e.preventDefault();

			$submit.addClass('hidden');
			$pleaseWait.removeClass('hidden');

			$('.js-alert').addClass('hidden');

			let data = {
				FirstName: $firstName.val(),
				LastName: $lastName.val(),
				Email: $email.val(),
				Phone: $phone.val(),
				Address1: $address.val(),
				Address2: $address2.val(),
				City: $city.val(),
				State: $stateProvince.val(),
				ZIP: $postalCode.val(),
				Country: $country.val(),
				ModelNumber: $model.val(),
				PurchaseYear: $purchaseYear.val(),

				OptIn: $optIn.is(":checked"),

				ReplacementItem: $replacementItem.val()
			};

			$.ajax({
				url: '/api/salesforce/post-order-free-replacement',
				type: 'POST',
				data: data
			})
				.done(function (response) {
					// console.log("data equals:" + data);
					if(response.data.success === true) {
						$alertSuccess.removeClass('hidden');
						$replacementPartsForm[0].reset();
						formValidation.resetForm($form);
						grecaptcha.reset();
					} else {
						$alertDanger
						.removeClass('hidden')
						.find('.js-alert-text')
						.text(response.data.message);
					}
				})
				.fail(function (response) {
					$alertDanger
						.removeClass('hidden')
						.find('.js-alert-text')
						.text(response.responseJSON.userFriendlyMessages[0]);
				})
				.always(function () {
					window.scrollTo(0, 0);
					$submit.removeClass('hidden');
					$pleaseWait.addClass('hidden');
				});
		});
	};


	export function init() {
		countryStateSetup.init($country, $stateProvince);

		inputEventListeners();
		submitEventListener();

		// This may need a polyfill or fallback it is not supported in IE11
		let urlParams = new URLSearchParams(window.location.search);
		$replacementItem.val(urlParams.get('replacementItem'));
		$model.val(urlParams.get('modelNumber'));
	}
}

PFF.controllers.freeReplacementParts.init();



// WEBPACK FOOTER //
// ./js/PFF/controllers/freeReplacementParts.ts